import React, { useState } from "react";
import { Sun, CloudRain, Snowflake, CloudLightning, CloudSun, Cloudy, Tornado, CloudSnow, Wind } from "lucide-react";
import Card from "./Card";
import Dialog from "./Dialog";
import { useLocalStorage } from "../hooks/useLocalStorage";

const WEATHER_PRESETS = [
  { key: "sunny", label: "Sunny", Icon: Sun },
  { key: "partly-cloudy", label: "Partly Cloudy", Icon: CloudSun },
  { key: "cloudy", label: "Cloudy", Icon: Cloudy },
  { key: "rainy", label: "Rainy", Icon: CloudRain },
  { key: "snowy", label: "Snowy", Icon: CloudSnow },
  { key: "frost", label: "Frosty", Icon: Snowflake },
  { key: "stormy", label: "Stormy", Icon: CloudLightning },
  { key: "tornado", label: "Tornado", Icon: Tornado },
  { key: "windy", label: "Windy", Icon: Wind },
];

export default function WeatherCard() {
  const [weather, setWeather] = useLocalStorage("weatherCard.weather", "sunny");
  const [isEditOpen, setIsEditOpen] = useState(false);

  const currentWeather = WEATHER_PRESETS.find(w => w.key === weather);

  return (
    <>
      <Card title="Today's Weather" colorIndex={0} onEdit={() => setIsEditOpen(true)}>
        <div className="flex flex-col items-center justify-center gap-4 lg:gap-6 xl:gap-8 h-full min-h-0">
          <div className="flex items-center justify-center p-6 lg:p-8 xl:p-10 rounded-full bg-white shadow-inner">
            <currentWeather.Icon className="w-16 h-16 lg:w-20 lg:h-20 xl:w-24 xl:h-24 2xl:w-28 2xl:h-28 text-slate-700" />
          </div>
          <p className="text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-fredoka font-bold text-center">
            It is {weather.toUpperCase()} today!
          </p>
        </div>
      </Card>

      <Dialog isOpen={isEditOpen} onClose={() => setIsEditOpen(false)} title="Edit Weather">
        <div className="space-y-4">
          <p className="text-slate-600">Choose today's weather:</p>
          <div className="grid grid-cols-2 gap-3">
            {WEATHER_PRESETS.map(({ key, label, Icon }) => (
              <button
                key={key}
                onClick={() => {
                  setWeather(key);
                  setIsEditOpen(false);
                }}
                className={`flex flex-col items-center justify-center gap-2 rounded-xl py-4 border-2 transition hover:scale-105 ${
                  weather === key ? "bg-yellow-100 border-yellow-400" : "bg-slate-50 border-slate-200 hover:border-slate-300"
                }`}
              >
                <Icon className="w-8 h-8" />
                <span className="font-bold">{label}</span>
              </button>
            ))}
          </div>
        </div>
      </Dialog>
    </>
  );
}
